import React from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import FetchInputSelectOptions from '../../FetchInputSelectOptions';
import InputSelect from '../InputSelect';
import { fetchCampus } from '../../../services/censo_services';

const CampusInputSelect = ({ params, submitOnChange, ...props }) => {
  const { submitForm } = useFormikContext();

  return (
    <FetchInputSelectOptions params={params} fetchOptions={fetchCampus}>
      {({ options, isLoading }) => (
        <InputSelect
          name="campus"
          label="Campus"
          placeholder="Selecionar"
          options={options}
          isLoading={isLoading}
          getOptionValue={(d) => d.id}
          getOptionLabel={(d) => d.nome}
          onChange={() => submitOnChange && submitForm()}
          {...props}
        />
      )}
    </FetchInputSelectOptions>
  );
};

CampusInputSelect.propTypes = {
  params: PropTypes.objectOf(PropTypes.node),
  submitOnChange: PropTypes.bool,
};

CampusInputSelect.defaultProps = {
  params: {},
  submitOnChange: false,
};

export default CampusInputSelect;
